"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils/utils");

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

var _fullscreenEvents = _interopRequireDefault(require("../constants/fullscreenEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenSocialDownload = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenSocialDownload, _React$Component);

  function FullscreenSocialDownload(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FullscreenSocialDownload.prototype;

  _proto.onKeyPress = function onKeyPress(e, downloadLink, curItem) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();

        if (_utils.utils.isiOS()) {
          _windowWrapper["default"].open(downloadLink);
        } else {
          _windowWrapper["default"].open(downloadLink, '_blank');
        }

        this.props.actions.eventsListener(_fullscreenEvents["default"].DOWNLOAD_BUTTON_CLICKED, curItem);
        return false;
    }
  };

  _proto.onKeyPressText = function onKeyPressText(e, curItem) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();
        this.props.actions.eventsListener(_fullscreenEvents["default"].TEXT_DOWNLOAD_BUTTON_CLICKED, curItem);
        return false;
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var arrowImageClass = 'progallery-svg-font-icons-download' + (this.props.hasAdditionalNavbarElement ? '-store' : '');
    var _this$props = this.props,
        device = _this$props.device,
        current = _this$props.current,
        styleParams = _this$props.styleParams;
    var curItem = current.item;
    var downloadUrl = styleParams.isStoreGallery ? 'download_sample' : 'download';
    var downloadLink = curItem.createUrl(downloadUrl, 'video') || curItem.createUrl(downloadUrl, 'img');
    var downloadClassNames = ["fullscreen-social-download " + arrowImageClass, device === 'desktop' ? 'fullscreen-icon' : '', 'has-custom-focus'].join(' ') + (_utils.utils.isMobile ? ' pro-fullscreen-mobile-social-icon' : '');
    return styleParams.allowDownload && !curItem.isDemo ? curItem.isText ? /*#__PURE__*/_react["default"].createElement("a", {
      className: downloadClassNames,
      style: this.props.style,
      tabIndex: 0,
      "aria-label": "Download " + curItem.type + " to your device",
      role: "button",
      title: 'Download',
      onClick: function onClick(evt) {
        evt.stopPropagation();

        _this2.props.actions.eventsListener(_fullscreenEvents["default"].TEXT_DOWNLOAD_BUTTON_CLICKED, curItem);
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyPressText(e, curItem);
      }
    }) :
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react["default"].createElement("a", {
      className: downloadClassNames,
      style: this.props.style,
      tabIndex: 0,
      "aria-label": "Download " + curItem.type + " to your device",
      role: "button",
      href: downloadLink,
      download: "download",
      title: 'Download',
      target: "_blank",
      onClick: /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
          var customDownloadUrl, url, _curItem$dto, mediaUrl, itemId;

          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  customDownloadUrl = _this2.props.customDownloadUrl;
                  url = downloadLink;

                  if (!customDownloadUrl) {
                    _context.next = 14;
                    break;
                  }

                  _curItem$dto = curItem.dto, mediaUrl = _curItem$dto.mediaUrl, itemId = _curItem$dto.itemId;
                  _context.prev = 5;
                  _context.next = 8;
                  return customDownloadUrl(mediaUrl, itemId);

                case 8:
                  url = _context.sent;
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](5);
                  console.error('Failed to get custom download url', _context.t0);

                case 14:
                  if (_utils.utils.isiOS()) {
                    _windowWrapper["default"].open(url);
                  } else {
                    _windowWrapper["default"].open(url, '_blank');
                  }

                  _this2.props.actions.eventsListener(_fullscreenEvents["default"].DOWNLOAD_BUTTON_CLICKED, curItem);

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[5, 11]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(),
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyPress(e, downloadLink, curItem);
      }
    }) : false;
  };

  return FullscreenSocialDownload;
}(_react["default"].Component);

var _default = FullscreenSocialDownload;
exports["default"] = _default;